<template>
    <v-container class="pt-0">
        <v-row>
            <v-col cols="12" sm="12" class="pa-0">
                <v-stepper v-model="step" class="elevation-0">
                    <template>
                        <v-stepper-header class="elevation-0 stepperHeader">
                            <v-divider></v-divider>
                            <v-stepper-step editable step="1">{{
                                $t('service:checkModalService')
                            }}</v-stepper-step>
                            <v-divider></v-divider>
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <div>
                                    <h4>
                                        {{ $t('service:checkModalTekst') }}
                                    </h4>

                                    <ol class="checkModalList">
                                        <li
                                            v-for="item in this.getRegistryDictionaries.checkModal.reverse()"
                                            :key="item.index"
                                        >
                                            {{ item.field }}
                                        </li>
                                    </ol>
                                </div>
                            </v-stepper-content>
                        </v-stepper-items>
                    </template>
                </v-stepper>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            step: 1,
        }
    },
    computed: {
        ...mapGetters(['getRegistryDictionaries']),
    },
}
</script>
<style lang="sass" scoped>
.checkModalList > li
    margin: 15px 0
</style>
